<template>
    <div class="copyright" v-if="baseInfo != null">
        <div class="container">
            <p>

                برای استفاده از مطالب فروشگاه ایران مارت، داشتن «هدف غیرتجاری» و ذکر «منبع» کافیست. تمام حقوق اين وب‌سايت نیز برای <a style="transition: all .3s; color: #5862e3;" href="https://sahandazarco.com" target="_blank">شرکت سهند پیشرو بنیان آذر</a> (فروشگاه آنلاین ایران مارت) است.
                <!--تمامی حقوق این وبسایت  متعلق به {{baseInfo.ShopName}} می باشد و هرگونه کپی برداری از مطالب ، محتوا، نام ، نشانی و قالب آن پیگرد قانونی دارد.-->
                <br />
                <span class="karasystak">طراحی و توسعه توسط   <a target="_blank" href="https://punas.ir/" title="طراحی وبسایت توسط پوناس">پوناس</a></span>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;    
            }
        }
    }
</script>

<style scoped>
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .copyright p {
            text-align: justify;
            padding-bottom: 40px;
        }
    }
    @media only screen and (min-width: 641px) and (max-width: 1077px) {
        .copyright p {
            text-align: center;
            padding-bottom: 40px;
        }
    }
</style>